'use es6';

import { IMPORT } from 'customer-data-filters/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { makeRecordMembershipAdapter } from './makeRecordMembershipAdapter';
const IMPORT_FETCH_LIMIT = 5000;
const makeImportAdapter = () => {
  return makeRecordMembershipAdapter({
    supportedAssetFamily: IMPORT,
    makeRequestUrl: objectTypeId => `inbounddb-io/imports/names/${objectTypeId}?limit=${IMPORT_FETCH_LIMIT}`,
    makeRequestOptions: () => {
      return {
        timeout: 60000
      };
    },
    getDataFromResponse: response => response[0].options,
    getIdFromResponseObject: responseObject => responseObject.value,
    getLabelFromResponseObject: responseObject => responseObject.label
  });
};
export default makeImportAdapter();